export enum CashierShiftStatus { 
  Open = 0,
  Closed = 1
}

export interface CreateCashierShiftDto {
  name: string;
  description?: string;
  uniqueCode?: string;
  createdDate?: Date;
  cashShiftStart: Date;
  cashShiftEnd: Date;
  cashRegisterRetailId?: string;
  status?: number;
}